import { logService } from "@Engage.Core";
export class G2IPlugin {
    constructor(config) {
        this.config = config;
        this.name = "G2I";
    }
    async init() {
        try {
            // g2insights.min.js is merged into the bundle at build time — no loadScript needed
            const g2i = window.G2Insights;
            if (!(g2i === null || g2i === void 0 ? void 0 : g2i.init)) {
                throw new Error("G2Insights.init is not available — script may not have merged correctly");
            }
            g2i.init(this.config);
            logService.log("[G2IPlugin] initialized");
        }
        catch (error) {
            logService.error("[G2IPlugin] Failed to initialize", error);
        }
    }
}
